export enum BelActionTypes {
  INITIATE_BEL_START = '@@bel/INITIATE_BEL_START',
  INITIATE_BEL_SUCCESS = '@@bel/INITIATE_BEL_SUCCESS',
  INITIATE_BEL_FAILURE = '@@bel/INITIATE_BEL_FAILURE',

  UPLOAD_FILE_START = '@@bel/UPLOAD_FILE_START',
  UPLOAD_FILE_SUCCESS = '@@bel/UPLOAD_FILE_SUCCESS',
  UPLOAD_FILE_FAILURE = '@@bel/UPLOAD_FILE_FAILURE',

  TRANSFORM_FILE_START = '@@bel/TRANSFORM_FILE_START',
  TRANSFORM_FILE_SUCCESS = '@@bel/TRANSFORM_FILE_SUCCESS',
  TRANSFORM_FILE_FAILURE = '@@bel/TRANSFORM_FILE_FAILURE',

  VALIDATE_FILE_START = '@@bel/VALIDATE_FILE_START',
  VALIDATE_FILE_SUCCESS = '@@bel/VALIDATE_FILE_SUCCESS',
  VALIDATE_FILE_FAILURE = '@@bel/VALIDATE_FILE_FAILURE',

  POLL_JOB_START = '@@bel/POLL_JOB_START',
  POLL_JOB_UPDATE = '@@bel/POLL_JOB_UPDATE',
  POLL_JOB_COMPLETE = '@@bel/POLL_JOB_COMPLETE',
  POLL_JOB_FAILURE = '@@bel/POLL_JOB_FAILURE',
  POLL_JOB_TIMEOUT = '@@bel/POLL_JOB_TIMEOUT',

  FETCH_BEL_SUCCESS = '@@bel/FETCH_BEL_SUCCESS',
  FETCH_BEL_FAILURE = '@@bel/FETCH_BEL_FAILURE',

  FETCH_LIVE_PRICE_START = '@@bel/FETCH_LIVE_PRICE_START',
  FETCH_LIVE_PRICE_SUCCESS = '@@bel/FETCH_LIVE_PRICE_SUCCESS',
  FETCH_LIVE_PRICE_FAILURE = '@@bel/FETCH_LIVE_PRICE_FAILURE',

  SUBMIT_BEL_DETAILS_START = '@@bel/SUBMIT_BEL_DETAILS_START',
  SUBMIT_BEL_DETAILS_SUCCESS = '@@bel/SUBMIT_BEL_DETAILS_SUCCESS',
  SUBMIT_BEL_DETAILS_FAILURE = '@@bel/SUBMIT_BEL_DETAILS_FAILURE',

  FETCH_DOWNLOAD_START = '@@bel/FETCH_DOWNLOAD_START',
  FETCH_DOWNLOAD_SUCCESS = '@@bel/FETCH_DOWNLOAD_SUCCESS',
  FETCH_DOWNLOAD_FAILURE = '@@bel/FETCH_DOWNLOAD_FAILURE',

  CREATE_BEL_CHECKOUT_START = '@@bel/CREATE_BEL_CHECKOUT_START',
  CREATE_BEL_CHECKOUT_SUCCESS = '@@bel/CREATE_BEL_CHECKOUT_SUCCESS',
  CREATE_BEL_CHECKOUT_FAILURE = '@@bel/CREATE_BEL_CHECKOUT_FAILURE',
  CONFIRM_BEL_PAYMENT = '@@bel/CONFIRM_BEL_PAYMENT',
  VERIFY_BEL_PAYMENT = '@@bel/VERIFY_BEL_PAYMENT',
  VERIFY_BEL_PAYMENT_SUCCESS = '@@bel/VERIFY_BEL_PAYMENT_SUCCESS',
  RESET_BEL_PAYMENT = '@@bel/RESET_BEL_PAYMENT',

  SET_STEP = '@@bel/SET_STEP',
  SET_SHAPE_HANDLING = '@@bel/SET_SHAPE_HANDLING',
  SET_ENQUIRY_DETAILS = '@@bel/SET_ENQUIRY_DETAILS',
  SET_VALIDATION_SUMMARY = '@@bel/SET_VALIDATION_SUMMARY',
  SET_BUFFER_DISTANCE = '@@bel/SET_BUFFER_DISTANCE',
  SET_MAX_SPLIT_AREA = '@@bel/SET_MAX_SPLIT_AREA',
  SET_APPLY_BUFFER = '@@bel/SET_APPLY_BUFFER',
  SET_APPLY_SPLIT = '@@bel/SET_APPLY_SPLIT',
  VALIDATE_GEOMETRY_SETTINGS_START = '@@bel/VALIDATE_GEOMETRY_SETTINGS_START',
  VALIDATE_GEOMETRY_SETTINGS_SUCCESS = '@@bel/VALIDATE_GEOMETRY_SETTINGS_SUCCESS',
  VALIDATE_GEOMETRY_SETTINGS_FAILURE = '@@bel/VALIDATE_GEOMETRY_SETTINGS_FAILURE',
  CLEAR_GEOMETRY_SETTINGS_VALIDATION = '@@bel/CLEAR_GEOMETRY_SETTINGS_VALIDATION',
  APPLY_GEOMETRY_PIPELINE_START = '@@bel/APPLY_GEOMETRY_PIPELINE_START',
  APPLY_GEOMETRY_PIPELINE_SUCCESS = '@@bel/APPLY_GEOMETRY_PIPELINE_SUCCESS',
  APPLY_GEOMETRY_PIPELINE_FAILURE = '@@bel/APPLY_GEOMETRY_PIPELINE_FAILURE',
  CLEAR_GEOMETRY_PIPELINE_ERROR = '@@bel/CLEAR_GEOMETRY_PIPELINE_ERROR',
  RESET_BEL = '@@bel/RESET_BEL'
}

export type BelShapeHandling = 'AUTO_SPLIT' | 'KEEP_ORIGINAL' | null;

export type BelJobStatus = 'PENDING' | 'PROCESSING' | 'COMPLETED' | 'FAILED';

export type BelProcessingPhase =
  | 'IDLE'
  | 'UPLOADING_FILE'
  | 'TRANSFORMING_FILE'
  | 'VALIDATING_FILE'
  | 'SUBMITTING'
  | 'PROCESSING'
  | 'COMPLETED'
  | 'TIMEOUT'
  | 'ERROR';

export type BelPaymentStatus =
  | 'idle'
  | 'creating'
  | 'invoice'
  | 'checkout'
  | 'confirming'
  | 'confirmed'
  | 'failed';

/** How the job poller interprets completion (see sagas). */
export type BelPollMode = 'transform' | 'bulkStatus' | null;

export interface BelEnquiryDetails {
  /** ISO yyyy-mm-dd */
  digStartAt: string;
  /** ISO yyyy-mm-dd */
  digEndAt: string;
  activityType: string;
  activityTypes: string[];
  /** @deprecated Single-select era; use `activityTypes`. Optional for merged branches / rehydrated state. */
  activity?: string;
  /** UI checkboxes: Footpath, Nature strip, Road, Private */
  locationTypes: string[];
  /** When true, map user_reference from the selected file attribute column. */
  useShapeNamesFromFile: boolean;
  /** Shapefile attribute column name (e.g. USER_REF, user_reference). */
  userReferenceProperty: string;
  userReference: string;
  autoRenew: boolean;
  /** ISO yyyy-mm-dd when autoRenew */
  autoRenewUntil: string;
  notes: string;
}

export interface BelFileInfo {
  fileId: number | null;
  fileName: string;
  fileSize: string;
  polygonCount: number;
  isValid: boolean;
}

export interface StripePrice {
  amount: number;
  currency: string;
  formatted: string;
  formattedWithTax?: string;
  stripeProductId: string | null;
}

export interface BelShapeFileField {
  name: string;
  type: string;
}

export interface BelValidationSummary {
  hasNonPointGeometry: boolean;
  geometryTypes: string[];
  totalFeatures: number;
  totalFeaturesInFile: number;
  totalAreaSqm: number;
  maxLineLengthM?: number;
  hasPolygonExceeding20Km2?: boolean;
  skippedUnderMinArea: number;
  fields?: BelShapeFileField[];
}

export interface BelGeometryViolation {
  featureIndex: number;
  geometryType: string;
  bufferedAreaSqm: number;
  code: string;
  message: string;
}

export interface BelGeometrySettingsValidation {
  loading: boolean;
  canProceed: boolean | null;
  requiresSplit: boolean;
  violations: BelGeometryViolation[];
  error: string | null;
  pendingStepAdvance: boolean;
}

export interface BelState {
  currentStep: number;
  loading: boolean;
  error: string | null;

  fileInfo: BelFileInfo | null;

  shapeHandling: BelShapeHandling;
  bufferDistance: number;
  maxSplitAreaKm: number;
  applyBuffer: boolean;
  applySplit: boolean;

  hasNonPointGeometry: boolean;
  validationSummary: BelValidationSummary | null;
  geometrySettingsValidation: BelGeometrySettingsValidation;
  /** True after buffer/split pipeline completed on the Upload step. */
  geometryPipelineApplied: boolean;
  /** True when buffer/split pipeline failed on the Upload step. */
  geometryPipelineFailed: boolean;

  enquiryDetails: BelEnquiryDetails;

  belId: number | null;
  bulkStatus: string | null;
  jobId: number | null;
  jobStatus: BelJobStatus | null;
  processingPhase: BelProcessingPhase;
  pollMode: BelPollMode;
  stripePrice: StripePrice | null;
  livePriceLoading: boolean;
  livePriceError: string | null;

  paymentStatus: BelPaymentStatus;
  checkoutClientSecret: string | null;
  invoiceId: string | null;
  isPostpay: boolean;
  transactionReference: string | null;

  enquiriesLodged: number | null;
  termsAccepted: boolean;

  downloadUrl: string | null;
  originalFileType: string | null;
  totalBulkEnquiries: number | null;
  totalEnquiriesCreated: number | null;
  updatedFileId: number | null;
}

export const INITIAL_BEL_STATE: BelState = {
  currentStep: 0,
  loading: false,
  error: null,
  fileInfo: null,
  shapeHandling: null,
  bufferDistance: 10,
  maxSplitAreaKm: 1.0,
  applyBuffer: false,
  applySplit: false,
  hasNonPointGeometry: false,
  validationSummary: null,
  geometrySettingsValidation: {
    loading: false,
    canProceed: null,
    requiresSplit: false,
    violations: [],
    error: null,
    pendingStepAdvance: false
  },
  geometryPipelineApplied: false,
  geometryPipelineFailed: false,
  enquiryDetails: {
    digStartAt: '',
    digEndAt: '',
    activityType: '',
    activityTypes: [],
    locationTypes: [],
    useShapeNamesFromFile: false,
    userReferenceProperty: '',
    userReference: '',
    autoRenew: false,
    autoRenewUntil: '',
    notes: ''
  },
  belId: null,
  bulkStatus: null,
  jobId: null,
  jobStatus: null,
  processingPhase: 'IDLE',
  pollMode: null,
  stripePrice: null,
  livePriceLoading: false,
  livePriceError: null,
  paymentStatus: 'idle',
  checkoutClientSecret: null,
  invoiceId: null,
  isPostpay: false,
  transactionReference: null,
  enquiriesLodged: null,
  termsAccepted: false,
  downloadUrl: null,
  originalFileType: null,
  totalBulkEnquiries: null,
  totalEnquiriesCreated: null,
  updatedFileId: null
};
